import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex gap-2"
};
const _hoisted_2 = {
  class: "pt-1 ps-2"
};
import LlTooltip from '@/components/LlTooltip.vue';
export default {
  __name: 'LlSwitch',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    info: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Boolean,
      required: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    useColorForBase: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: 'success'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: [Boolean, String],
      default: true
    },
    density: {
      type: String,
      default: 'compact'
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const handleUpdateValue = value => {
      emit('update:modelValue', value);
      emit('change', value);
    };
    const toggleCheckbox = () => {
      if (props.disabled) return;
      const newValue = !props.modelValue;
      emit('update:modelValue', newValue);
      emit('change', newValue);
    };
    return (_ctx, _cache) => {
      const _component_v_switch = _resolveComponent("v-switch");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_switch, {
        "data-cy": "ll-switch",
        "model-value": __props.modelValue,
        "onUpdate:modelValue": handleUpdateValue,
        color: __props.color,
        "base-color": __props.useColorForBase ? __props.color : undefined,
        disabled: __props.disabled,
        "hide-details": __props.hideDetails,
        density: __props.density
      }, null, 8, ["model-value", "color", "base-color", "disabled", "hide-details", "density"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("label", {
        class: _normalizeClass(__props.labelClass),
        onClick: toggleCheckbox
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), _withDirectives(_createVNode(LlTooltip, {
        text: __props.info,
        icon: "help"
      }, null, 8, ["text"]), [[_vShow, __props.info.length]])], 2)])]);
    };
  }
};